var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnarounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.99951 7.00049C7.44723 7.00049 6.99951 6.55277 6.99951 6.00049C6.99951 5.4482 7.44723 5.00049 7.99951 5.00049L15.9995 5.00049C18.2087 5.00049 19.9995 6.79135 19.9995 9.00049C19.9995 11.2096 18.2087 13.0005 15.9995 13.0005H7.99951C6.89494 13.0005 5.99951 13.8959 5.99951 15.0005C5.99951 16.1051 6.89494 17.0005 7.99951 17.0005H16.9995C17.5518 17.0005 17.9995 17.4482 17.9995 18.0005C17.9995 18.5528 17.5518 19.0005 16.9995 19.0005H7.99951C5.79037 19.0005 3.99951 17.2096 3.99951 15.0005C3.99951 12.7913 5.79037 11.0005 7.99951 11.0005H15.9995C17.1041 11.0005 17.9995 10.1051 17.9995 9.00049C17.9995 7.89592 17.1041 7.00049 15.9995 7.00049H7.99951Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70662 8.29338C10.0971 8.68391 10.0971 9.31707 9.70662 9.70759C9.31609 10.0981 8.68293 10.0981 8.29241 9.70759L5.29241 6.70759C4.90188 6.31707 4.90188 5.68391 5.29241 5.29338L8.29241 2.29338C8.68293 1.90286 9.31609 1.90286 9.70662 2.29338C10.0971 2.68391 10.0971 3.31707 9.70662 3.70759L7.41373 6.00049L9.70662 8.29338Z",
    fill: "#B0B7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2934 20.2934C13.9029 20.6839 13.9029 21.3171 14.2934 21.7076C14.6839 22.0981 15.3171 22.0981 15.7076 21.7076L18.7076 18.7076C19.0981 18.3171 19.0981 17.6839 18.7076 17.2934L15.7076 14.2934C15.3171 13.9029 14.6839 13.9029 14.2934 14.2934C13.9029 14.6839 13.9029 15.3171 14.2934 15.7076L16.5863 18.0005L14.2934 20.2934Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnarounds);
export default __webpack_public_path__ + "static/media/turnarounds.89e1afb171b141f39bfd6eee84d72212.svg";
export { ForwardRef as ReactComponent };